import Vue from 'vue'
import Vuetify from 'vuetify'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#38668e',
        secondary: '#3f434e',
        accent: '#66cc66',
        error: '#ff9933',
        gray: '#8a97a4',
        white: '#ffffff',
        red: '#ad2e3a',
        lightgrey: '#d8d8d8'
      }
    }
  }
})

Vue.prototype.$vuetify = vuetify.framework

export default vuetify
